import { Injectable } from '@angular/core';
import { BaseClient } from '../common/client/base.client';
import { SvcClients } from '../common/client/SvcClients';

@Injectable({
  providedIn: 'root',
})
export class UserJournalClient extends BaseClient {
  constructor() {
    super();
  }

  //#region MANAGER ACCOUNTS

  userJournalUsersSearch(message: string, filter: any) {
    if (filter?.length >= 4)
      return this.get(
        SvcClients.AdminSvc,
        `PDAPUserJournal/UserJournalUsersSearch?filter=${filter}`,
        message
      );
    else return Promise.resolve({ result: [] });
  }

  userJournalLocationsSearch(message: string, filter: any) {
    if (filter?.length >= 4)
      return this.get(
        SvcClients.AdminSvc,
        `PDAPUserJournal/UserJournalLocationsSearch?filter=${filter}`,
        message
      );
    else return Promise.resolve({ result: [] });
  }

  userJournalGet(message: string, model: any) {
    return this.post(
      SvcClients.AdminSvc,
      `PDAPUserJournal/UserJournalGet`,
      model,
      message
    );
  }


}


